{
    "alts": {
        "closeModal": "Close modal"
    },
    "buttons": {
        "next": "Continue",
        "tryAgain": "Try Again",
        "finish": "Finish",
        "submit": "Submit",
        "confirm": "Confirm",
        "agree": "I Agree",
        "downloadPDF": "Download as PDF",
        "yes": "Yes",
        "no": "No",
        "verify": "Verify",
        "skip": "Skip",
        "close": "Close",
        "consent": {
            "confirmQuietPlace": "I’m in a Quiet Place",
            "confirmYourBest": "I’ll Do My Best",
            "confirmAid": "I Confirm",
            "confirmOnYourOwn": "I’ll Do Tasks On My Own",
            "confirmLater": "I'll Come Back Later"
        },
        "exit": "Exit",
        "exit2": "No, Exit",
        "exit3": "Exit & Lose Progress",
        "invite": "Send Invitation",
        "sendAnotherInvite": "Send Another Invitation?",
        "start": "Start Test",
        "cantVerifyNow": "Can't Verify Now"
    },
    "placeholders": {
        "month": "Month",
        "year": "Year",
        "day": "Day",
        "location": "For example, NW3 6PX"
    },
    "months": [
        "Empty",
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    "errors": {
        "wer": [
            {
                "title": "Uh-oh. We didn’t catch what you said there.",
                "instructions": "- Remember the recording begins automatically.\n- Make sure you repeat the sentence and nothing else.\n- Press the stop button when you have finished.",
                "button": "Try Again"
            },
            {
                "title": "Hmm. We still didn’t catch what you said there.",
                "instructions": "- Remember the recording begins automatically.\n- Make sure you repeat the sentence and nothing else.\n- Press the stop button when you have finished.",
                "button": "Try One Last Time"
            }
        ],
        "noise": [
            {
                "title": "Uh-oh, it sounds like there is some background noise.",
                "instructions": "Please find a quieter place or switch off anything that is making noise (TV, music, etc.), and make sure no one is talking in the background.",
                "button": "Try Again"
            },
            {
                "title": "Hmm, it sounds like there is still some background noise.",
                "instructions": "Please find a quieter place or switch off anything that is making noise (TV, music, etc.), and make sure no one is talking in the background.",
                "button": "Try One Last Time"
            }
        ],
        "clipping": [
            {
                "title": "The recording is too loud.",
                "instructions": "- Consider moving your microphone a bit further away from you.\n- Try speaking a little more quietly.\n- Make sure you are in a quiet place.",
                "button": "Try Again"
            },
            {
                "title": "The recording is still too loud.",
                "instructions": "- Consider moving your microphone a bit further away from you.\n- Try speaking a little more quietly.\n- Make sure you are in a quiet place.",
                "button": "Try One Last Time"
            }
        ],
        "sex": {
            "error": {
                "required": "Please select your assigned sex at birth before proceeding."
            }
        },
        "email": {
            "error": {
                "duplicate": "It seems this email is already used. Try another one or contact support.",
                "required": "Enter your email address before proceeding.",
                "pattern": "This doesn’t appear to be a valid email. Try another one or contact support."
            }
        },
        "consent": {
            "error": {
                "required": "Please confirm that you agree before proceeding."
            }
        },
        "proficiency": {
            "error": {
                "required": "Choose your language proficiency before proceeding."
            }
        },
        "education": {
            "error": {
                "required": "Please select the option that best reflects your education level before proceeding."
            }
        },
        "study_consent": {
            "error": {
                "required": "Confirm your agreement to proceed."
            }
        },
        "dob": {
            "error": {
                "required": "Please provide your date of birth before proceeding.",
                "composite": "Please provide your date of birth before proceeding."
            }
        },
        "location": {
            "error": {
                "required": "Provide your home postcode before proceeding.",
                "composite": "Provide your home postcode before proceeding."
            }
        },
        "code": {
            "error": {
                "required": "Incorrect code. Double check your phone number and request another code.",
                "bad request": "Incorrect code. Double check your phone number and request another code."
            }
        },
        "had-impairment-issues": {
            "error": {
                "required": "Please, answer if you have any vision or hearing impairments."
            }
        },
        "got-distracted": {
            "error": {
                "required": "Please, answer if you managed to complete the tasks without distraction."
            }
        },
        "someone-else-speaking": {
            "error": {
                "required": "Please, answer if we recorded anyone except you talking during the tasks."
            }
        },
        "phone": {
            "error": {
                "duplicate": "It seems this phone number is already used. Try another one or contact support.",
                "required": "Enter your phone number before proceeding."
            }
        },
        "isCaregiver": {
            "error": {
                "required": "Choose whether the test is for you or for someone else before proceeding."
            }
        },
        "isPersonNearby": {
            "error": {
                "required": "Please answer the question before proceeding."
            }
        },
        "caregiverShare": {
            "error": {
                "required": "Choose how you would like to send the test invitation link before proceeding."
            }
        },
        "inviteeEmail": {
            "error": {
                "duplicate": "It seems this email is already used. Try another one or contact support.",
                "required": "Enter the recipient's email address to send the test invitation.",
                "minLength": "Enter the recipient's email address to send the test invitation."
            }
        },
        "inviteePhone": {
            "error": {
                "duplicate": "It seems this phone number is already used. Try another one or contact support.",
                "required": "Enter the recipient's mobile phone number to send the test invitation.",
                "minLength": "Enter the recipient's mobile phone number to send the test invitation."
            }
        }
    },
    "modals": {
        "exit": {
            "caption": "Exit Storyteller?",
            "text": "You will be able to come back when you are ready.",
            "buttons": {
                "confirm": "Exit",
                "cancel": "No"
            }
        },
        "expired": {
            "caption": "Session has expired",
            "text": "You’ve been away for a while, so your session has ended. Press **Restart** to go back to the beginning of Storyteller.",
            "buttons": {
                "confirm": "Restart",
                "cancel": "Exit"
            }
        },
        "genericError": {
            "caption": "Something went wrong.",
            "text": "We apologize for the inconvenience. It seems that something is not working correctly on our end. Please click **Try Again** to continue. If the issue persists, please contact support.",
            "buttons": {
                "confirm": "Try Again",
                "cancel": "Exit"
            }
        },
        "soundCheck": {
            "caption": "Did you hear the sound?"
        },
        "completeStreaming": {
            "caption": "Have you finished?"
        }
    },
    "phone": {
        "resend": "Request another code",
        "change": "Change phone number",
        "timeout": "Request another code in {{counter}}s",
        "prefix": "New code sent!"
    },
    "consent": {
        "title": "Consent",
        "description": "Carefully read the consent form and indicate your agreement."
    },
    "recording": "Recording in progress",
    "streaming": {
        "play": "Press to Start",
        "playing": "Listen",
        "record": "Press to Start",
        "recordingAutomatic": "Speak",
        "recordingManual": "Press to Stop"
    },
    "soundCheck": {
        "audioStart": "Check Sound",
        "audioStop": "Listen"
    },
    "options": {
        "proficiency": {
            "native": "Native",
            "fluent": "Fluent",
            "not-native-or-fluent": "Not native or fluent"
        },
        "language": {
            "en-US": "English (USA)",
            "en-GB": "English (UK)",
            "es-US": "Spanish (USA)"
        },
        "novoicConsent": [
            "I have read and accepted Novoic's Terms of Use and Privacy Policy. I understand that Novoic does not provide medical advice or health-related recommendations. I understand that Novoic's partner research sites will decide if I am suitable for their ongoing trials or research studies."
        ],
        "yes": "Yes",
        "no": "No",
        "csat": {
            "low": "Not at all",
            "high": "Very much"
        },
        "csatADNI": {
            "low": "Not at all",
            "high": "Very much"
        },
        "studyMotivation": {
            "improve_others_life": "I want to help improve the lives of others",
            "memory_concerns": "I am concerned about my memory",
            "noticed_memory_decline": "I have noticed a decline in my memory",
            "relative_with_ad": "I have a relative with Alzheimer’s Disease",
            "been_diagnosed_with_ad": "I have been diagnosed with Alzheimer’s Disease or Mild Cognitive Impairment",
            "want_money": "I would like to be paid for taking part in research",
            "looking_for_clinical_contact": "I am looking for clinical contact or treatment as part of a clinical trial"
        },
        "sex": {
            "male": "Male",
            "female": "Female",
            "other": "Other"
        },
        "consent": {
            "accept": "I have read and accepted Novoic's Terms of Use and Privacy Policy. I understand that Novoic does not provide medical advice or health-related recommendations. I understand that Novoic's partner research sites will decide if I am suitable for their ongoing trials or research studies."
        },
        "education": {
            "didnt_complete_high_school": "Did not complete high school or upper secondary education",
            "high_school": "Completed high school or upper secondary education",
            "upper_secondary": "Some post upper secondary education after completing high school or upper secondary education",
            "bachelors_degree": "Completed bachelor’s degree or equivalent",
            "masters_degree": "Completed master’s degree, equivalent or higher"
        },
        "hispanic": {
            "no": "No, I am not Hispanic or Latino\/a",
            "yes": "Yes, I am Hispanic or Latino\/a",
            "unknown": "Unknown"
        },
        "race": {
            "american_indian_or_alaska_native": "American Indian or Alaska Native",
            "asian": "Asian",
            "african_american": "Black or African American",
            "hawaiian_or_other_islander": "Native Hawaiian or other Pacific Islander",
            "white": "White",
            "other": "Other",
            "asian_or_asian_british": "Asian or Asian British",
            "black_black_british_carribean_or_afrikan": "Black, Black British, Carribean or African",
            "mixed_or_multiple_groups": "Mixed or multiple ethnic groups"
        },
        "isCaregiver": {
            "myself": "I want to take the test myself",
            "someone-else": "The test is for someone else"
        },
        "isPersonNearby": {
            "yes": "Yes, they are here and ready",
            "no": "No, I'd like to send them an invitation so they can take the test later"
        },
        "caregiverShare": {
            "email": "Via email",
            "sms": "Via text message (SMS) to a mobile phone number"
        },
        "study_consent": {
            "agree": "I agree to participate."
        }
    },
    "screens": {
        "welcomeSelfService": {
            "title": "Welcome to Novoic Storyteller! 👋",
            "description": "Here you can be matched to clinical studies from the comfort of your own home.",
            "language": "First, please choose your native or most fluent language:",
            "proficiencyPlaceholder": "Choose proficiency level..."
        },
        "progressSaved": {
            "caption": "Your progress has been saved!",
            "instruction": "Check your email for a link to return to Storyteller at any time.",
            "action": "**You may close this window now.**"
        },
        "getMatched": {
            "caption": "Get matched to a clinical trial site in 3 simple steps:",
            "list": [
                "Answer a few questions to check your eligibility.",
                "Review and agree to a study consent.",
                "Test your brain age with some short speech-based tasks.",
                "Share your contact details, so site staff can get in touch if they think you're a good candidate for a more in-depth assessment."
            ]
        },
        "novoicPrivacy": {
            "caption": "We want you to know how our services work and how we use and share your data.",
            "description": "- We collect information to help our partner research sites decide whether you are a good match for an ongoing clinical trial.\n - We will share your personal information only with our partner research sites.\n - Please read through our [Terms of Use](https:\/\/novoic.com\/storyteller\/tos) and [Privacy Policy](https:\/\/novoic.com\/storyteller\/privacy) for more details."
        },
        "studyMotivation": {
            "caption": "What motivates you to join a research study?",
            "description": "This question is optional. Please select all that apply."
        },
        "email": {
            "caption": "What is your email address?",
            "comment": "By entering your email address, you are agreeing that we, or our study partners, may contact you about a study in the future. See our [Privacy Policy](https:\/\/novoic.com\/storyteller\/privacy) for details.",
            "emailPlaceholder": "Your email address...",
            "descriptionOptional": "This is optional. Input your or your caregiver's email to receive a link allowing you to take a break and resume later without losing progress.",
            "descriptionRequired": "We, or our partners, will use it to contact you about the study."
        },
        "name": {
            "caption": "What is your full name?",
            "namePlaceholder": "Your full name..."
        },
        "dob": {
            "caption": "What is your date of birth?",
            "description": "This helps check your fit against the study age requirements."
        },
        "excludedAge": {
            "caption": "We appreciate your interest, but we can’t include you in Storyteller right now.",
            "description": "Storyteller is currently only available to participants aged 50 and above. Thank you for your consideration!",
            "action": "**You may close this window now.**"
        },
        "excludedLanguage": {
            "caption": "We appreciate your interest, but we can’t include you in Storyteller right now.",
            "description": "Storyteller is only available right now to people who are native speakers or fluent in the chosen language. Thank you for your consideration!",
            "action": "**You may close this window now.**"
        },
        "sex": {
            "caption": "What was your assigned sex at birth?"
        },
        "education": {
            "caption": "At what stage did you complete your schooling?",
            "description": "This might be relevant to your study inclusion."
        },
        "hispanic": {
            "caption": "Are you of Hispanic or Latino ethnicity?",
            "description": "This question is optional. This helps us to ensure that the study is inclusive and representative."
        },
        "race": {
            "caption": "How would you describe your racial background?",
            "description": "This question is optional. This helps us to ensure that the study is inclusive and representative. Please select all that apply."
        },
        "noSites": {
            "caption": "Do you want to be contacted when there is a site recruiting near you?",
            "description": "There are no research sites that are recruiting near you right now, but there may be in the future. Share your email to be contacted about future opportunities or other studies that may interest you.",
            "emailPlaceholder": "Your email address...",
            "comment": "Your privacy is important to us. See our [Privacy Policy](https:\/\/novoic.com\/storyteller\/privacy) for details."
        },
        "studymatchSuccess": {
            "caption": "Study match success!",
            "description": "Your answers indicate that you may be a good fit for a clinical trial or study, and we have found a study site near you that is recruiting.",
            "action": "**Are you ready for some quick speech-based memory tasks? Then please continue to read our study information sheet and consent form.**"
        },
        "demographicsComplete": {
            "caption": "Thank you! Now on to the speech-based tasks.",
            "next": "Please listen for instructions and answer by simply talking back. Your answers will be recorded and analyzed. The results will be shared with the research site, where they will decide if and when to contact you for their study.",
            "action": "You can do this now or come back later (we'll send you a link)."
        },
        "confirmTime": {
            "caption": "Confirm that you are in a quiet place and will not be disturbed for the next 10 minutes.",
            "instruction": "Please switch off any other devices that are making noise around you (television, radio), or move to a quieter place if it's noisy where you are."
        },
        "saveProgress": {
            "caption": "Be sure to enter your email to save your progress!",
            "description": "You'll receive a link that allows you to take a break and continue the test later without losing progress.",
            "emailPlaceholder": "Your email address...",
            "comment": "Your privacy is important to us. See our [Privacy Policy](https:\/\/novoic.com\/storyteller\/privacy) for details."
        },
        "leave": {
            "caption": "We are sad to see you go.",
            "description": "We hope you might want to give contributing to clinical research another chance.",
            "action": "**You may close this window now.**"
        },
        "confirmAid": {
            "caption": "Confirm that you are wearing your glasses and\/or hearing aid if you normally use these.",
            "description": "It is important that you can hear and read the instructions clearly."
        },
        "confirmOnYourOwn": {
            "caption": "Confirm that you will do the tasks on your own and without taking notes.",
            "description": "It is important that you do not let someone help you answer and do not take any notes."
        },
        "confirmFocus": {
            "caption": "Confirm that you will try to focus and do your best!",
            "description": "Some tasks might be quite challenging – they are supposed to be. Don't worry, most people make a lot of mistakes. But for accurate data, it is important that you do your very best."
        },
        "soundCheck": {
            "caption": "Turn up the volume on your device and then press the button to check the sound."
        },
        "welcomeADNI": {
            "caption": "Welcome to Storyteller!",
            "description": "Here you will do some short spoken tasks to check your memory.",
            "instructions": "This will take around 10 minutes. As you complete Storyteller, you will hear task instructions. You can respond by simply talking back to your device. Your responses will be used to check your memory."
        },
        "studymatchComplete": {
            "caption": "You may close this window now.",
            "action": "Remember, you may receive an email or a phone call from a study site, if they decide that you are a good candidate."
        },
        "memoryComplete": {
            "caption": "Speech tasks completed!",
            "description": "We will share your responses with the site who may contact you to offer a more in-depth assessment, if they decide that you are a good candidate.",
            "action": "As a final step, please enter your contact details so we, or our partners, can reach you."
        },
        "csat": {
            "caption": "Thank you for completing Novoic Storyteller! 🎉",
            "question": "Did you enjoy completing Novoic Storyteller?",
            "action": "That’s one giant step forward in your contribution to clinical research. Please check your email for next steps."
        },
        "recordingPermissions": {
            "caption": "Now we need permission to access your microphone.",
            "description": "For the test to work we need to record you when you are speaking. We will only be able to record you during the test.",
            "instructions": "![Record Icon](https:\/\/novoic-static.s3.us-west-2.amazonaws.com\/rec.svg)&nbsp;&nbsp;**Note:** you will always see this red dot when the app is recording."
        },
        "noSound": {
            "caption": "Try the following steps and try again:",
            "instructions": "Go to Settings → Bluetooth and switch to off, or find this&nbsp;&nbsp;![Bluetooth](https:\/\/novoic-static.s3.us-west-2.amazonaws.com\/bluetooth.svg)&nbsp;&nbsp;icon and click on it to put it in ‘off’ mode.",
            "list": [
                {
                    "icon": "sound",
                    "text": "Adjust the volume or unmute your device."
                },
                {
                    "icon": "headset",
                    "text": "Disconnect any headsets\/earphones that you are using."
                },
                {
                    "icon": "bluetooth",
                    "text": "Disconnect from Bluetooth."
                }
            ]
        },
        "noMicrophone": {
            "caption": "It looks like your microphone permissions haven’t been granted.",
            "browsers": {
                "chrome": {
                    "title": "Google Chrome",
                    "icon": "chrome",
                    "instructions": "- Click the lock, shield or microphone icon in the address bar.\n - Change permissions to **Allow** and close the pop-up.\n - Click **Try Again**.\n - **Allow** access to your microphone in the popup on the next page."
                },
                "safari": {
                    "title": "Safari",
                    "icon": "safari",
                    "instructions": "#### First:\n - Press **Try Again**.\n - **Allow** access to the microphone in the popup on the next page.\n #### If unsuccessful:\n - Press on **Safari** in the menu bar, select **Preferences**.\n - Press the **Websites** tab and click **Microphone**.\n - Change our site’s permissions to **Allow**.\n - Close preferences and press **Try Again**.\n - **Allow** access to your microphone in the popup on the next page."
                },
                "firefox": {
                    "title": "Firefox",
                    "icon": "firefox",
                    "instructions": "- Click the microphone, lock or shield icon in the address bar.\n - Click on the **x** next to **Blocked**.\n - Click **Try Again**.\n - **Allow** access to your microphone in the popup on the next page."
                },
                "opera": {
                    "title": "Opera",
                    "icon": "opera",
                    "instructions": "- Click the microphone, lock or shield icon in the address bar.\n - Toggle microphone permissions and click **Done**.\n - Click **Try Again**.\n - **Allow** access to your microphone in the popup on the next page."
                },
                "edge": {
                    "title": "Microsoft Edge",
                    "icon": "edge",
                    "instructions": "- Click the microphone, lock or shield icon in the address bar.\n - Toggle microphone permissions and click **Done**.\n - Click **Try Again**.\n - **Allow** access to your microphone in the popup on the next page."
                }
            },
            "mobile": {
                "ios": {
                    "title": "iPhone \/ iPad",
                    "icon": "ios",
                    "instructions": "#### First:\n- Tap **Try Again**.\n - **Allow** access to your microphone in the popup on the next page.\n#### If unsuccessful:\n - Refresh the page by tapping the refresh symbol in the address bar.\n - Tap **Try Again**.\n - **Allow** access to your microphone in the popup on the next page."
                },
                "android": {
                    "title": "Android",
                    "icon": "android",
                    "instructions": "- Click the lock, shield or microphone icon near your address bar and enable microphone permissions if they're there. You may need to scroll to reveal the address bar. Afterwards, you may need to refresh the page.\n - Tap **Try Again**.\n - **Allow** access to your microphone in the popup on the next page."
                }
            }
        },
        "micCheck": {
            "captions": {
                "default": "Let’s check your microphone. We will tell you a sentence. Repeat it back when the button turns red.",
                "playing": "Listen carefully.",
                "recording": "Repeat the sentence."
            },
            "transcript": "Tonight there is a street party with music and dancing"
        },
        "asrt1": {
            "captions": {
                "default": "Now we will tell you a short story. Listen to the story and then retell it with as much detail as you can.",
                "playing": "Listen carefully.",
                "recording": "Retell the story in as much detail as you can."
            }
        },
        "asrt1success": {
            "caption": "Great job!",
            "description": "Continue to the next step when you are ready."
        },
        "asrt2": {
            "captions": {
                "default": "Now we will tell you another short story. Listen to the story and then retell it with as much detail as you can.",
                "playing": "Listen carefully.",
                "recording": "Retell the story in as much detail as you can."
            }
        },
        "asrt2success": {
            "caption": "Almost there!",
            "description": "Continue to the next step when you are ready."
        },
        "cat": {
            "instructions": "**For example**, if the category was 'plants' you might list ‘rose’, ‘oak’, etc. The recording will stop automatically after 60 seconds.",
            "captions": {
                "default": "We will name a category. List as many things in that category as you can for 60 seconds.",
                "playing": "Listen carefully.",
                "recording": "Name all the animals you can think of."
            },
            "cta": {
                "play": "Press To Start",
                "playing": "Listen",
                "recording": "Speak"
            }
        },
        "catSuccess": {
            "caption": "Ready for the final task?",
            "description": "Continue to the next step when you are ready."
        },
        "asrt1delayed": {
            "captions": {
                "default": "Press “Start” to listen to the instructions.",
                "playing": "Listen carefully.",
                "recording": "Retell the story in as much detail as you can."
            }
        },
        "survey": {
            "caption": "Please answer the following questions:",
            "someoneElseSpeaking": "Did we record anyone except you talking during the tasks?",
            "withoutDistraction": "Did you manage to complete the tasks without distraction?",
            "hearingImpairments": "Do you have any vision or hearing impairments?"
        },
        "csatADNI": {
            "caption": "Thank you for completing Storyteller!",
            "question": "Did you enjoy Storyteller?"
        },
        "micCheckSuccess": {
            "caption": "Great!",
            "description": "Both your speakers and microphone are working."
        },
        "noTest": {
            "caption": "This test is already completed or never existed.",
            "description": "If you have any questions, please [reach out to our support](https:\/\/help.novoic.com)."
        },
        "postcode": {
            "caption": "What is your home ZIP code?",
            "description": "This helps to match you to the closest research site.",
            "postcodePlaceholder": "For example, 10001"
        },
        "phoneInput": {
            "caption": "What is the best phone number to reach you?",
            "description": "Enter your phone number and press **Verify** to get your 4-digit verification code via text message:",
            "comment": "By entering your phone number, you are agreeing that we, or our study partners, may contact you about a study in the future. Calls may be recorded for quality purposes. See our [Privacy Policy](https:\/\/novoic.com\/storyteller\/privacy) for details.",
            "placeholder": "+1"
        },
        "registeringInterest": {
            "caption": "Thank you for registering your interest!",
            "description": "We will be in touch if and when we have a partner study recruiting with a site near you.",
            "action": "**You may close this window now.**"
        },
        "noSitesNearby": {
            "caption": "There are no research sites that are recruiting near you right now, but there may be in the future.",
            "description": "We will be in touch if and when we have a partner study recruiting with a site near you.",
            "action": "**You may close this window now.**"
        },
        "phoneVerification": {
            "caption": "Verify your phone number",
            "description": "Enter the 4-digit code from the text message sent to **{{phone}}:**",
            "resend": "**Didn’t get the code?**"
        },
        "language": {
            "caption": "Please choose your native or most fluent language:"
        },
        "isCaregiver": {
            "caption": "First, are you taking the test yourself, or is the test for someone else?"
        },
        "isPersonNearby": {
            "caption": "Is the person taking the test with you and ready to take the test?"
        },
        "caregiverWarning": {
            "caption": "Great! You may support the person completing the test to answer the on-screen questions, but please ensure they complete the speech tasks on their own.",
            "comment": "**Important:** It's crucial that the person completes the speech tasks independently, without any assistance."
        },
        "personalInvite": {
            "caption": "Make the invitation personal.",
            "description": "This is optional. Including the recipient's name and a familiar sender's name in the invitation could improve the chances of the recipient completing the test.",
            "senderNamePlaceholder": "Your full name",
            "recipientNamePlaceholder": "Recipient's name"
        },
        "caregiverShare": {
            "caption": "How would you like to send the test invitation?"
        },
        "inviteeEmailSent": {
            "caption": "Invitation sent!",
            "instruction": "Invitation with the test link has been sent to **{{email}}**",
            "action": "**You may close this window now.**"
        },
        "inviteeSMSSent": {
            "caption": "Invitation sent!",
            "instruction": "Invitation with the test link has been sent to **{{phone}}**",
            "action": "**You may close this window now.**"
        },
        "inviteeEmail": {
            "caption": "To invite someone to complete the test, please enter their email address here:",
            "comment": "By entering the email address, you confirm that you have the owner's consent and agree to allow us, or our research site partners, to contact them about potential trials. See our [Privacy Policy](https:\/\/novoic.com\/storyteller\/privacy) for details.",
            "emailPlaceholder": "Email address..."
        },
        "inviteeSMS": {
            "caption": "To invite someone to complete the test, please enter their mobile phone number here:",
            "placeholder": "+1",
            "comment": "By entering the phone number, you confirm that you have the owner's consent and agree to allow us, or our research site partners, to contact them about potential trials. Calls may be automated and recorded for quality purposes. See our [Privacy Policy](https:\/\/novoic.com\/storyteller\/privacy) for details."
        },
        "aggregatedConfirmations": {
            "caption": "You are about to start the speech-based tasks. Please confirm that you are:",
            "list": [
                {
                    "text": "In a quiet place where you will not be disturbed for the next 10 minutes.",
                    "icon": "quiet-place"
                },
                {
                    "text": "Wearing your glasses and\/or hearing aid if you normally use these.",
                    "icon": "have-aid"
                },
                {
                    "text": "Will do the tasks on your own and without taking notes.",
                    "icon": "no-notes"
                },
                {
                    "text": "Will try to focus and do your best!",
                    "icon": "on-my-own"
                }
            ]
        },
        "siteSpecificWelcome": {
            "title": "Welcome to Novoic Storyteller! 👋",
            "paragraph1": "{{site}} invites you to complete this short speech-based test.",
            "paragraph2": "Here, you will answer some questions about you, and complete some simple tasks by speaking into your device.",
            "paragraph3": "Your responses will be used to calculate your Brain Age, and shared securely with {{site}}, who may contact you to discuss your results."
        },
        "redirect": {
            "processing": "Processing...",
            "halt": "This is taking little longer than expected. Hold on...",
            "tooLong": "This shouldn’t have been taken so long.",
            "description": "Please click the ‘Continue’ button below to finalize the test."
        },
        "networkFailed": {
            "title": "Uh-oh, it looks like the connection was lost",
            "instructions": "- Try moving somewhere with a good internet connection.\n- If you’re using mobile internet, try connecting to WiFi.\n- If you’re using WiFi on a mobile device, try disconnecting and using your mobile internet instead."
        },
        "unsupportedBrowser": {
            "caption": "Please open Storyteller in a different internet browser",
            "instructions": "The Facebook app doesn’t support this test.\n\n&nbsp;\n\nTo continue, please do the following:\n- Tap the three dots (···) at the top of the page.\n- Select **Open in** ... to open Storyteller in your preferred internet browser, such as Chrome, Firefox, Edge or Safari."
        },
        "asrt3": {
            "captions": {
                "recording": "Retell the story in as much detail as you can.",
                "default": "Now we will tell you a short story. Listen to the story and then retell it with as much detail as you can.",
                "playing": "Listen carefully."
            }
        },
        "asrt3success": {
            "caption": "Great job!",
            "description": "Continue to the next step when you are ready."
        },
        "asrt3delayed": {
            "captions": {
                "default": "Press “Start” to listen to the instructions.",
                "playing": "Listen carefully.",
                "recording": "Retell the story in as much detail as you can."
            }
        },
        "asrt6": {
            "captions": {
                "default": "Now we will tell you another short story. Listen to the story and then retell it with as much detail as you can.",
                "playing": "Listen carefully.",
                "recording": "Retell the story in as much detail as you can."
            }
        },
        "asrt6success": {
            "caption": "Almost there!",
            "description": "Continue to the next step when you are ready."
        },
        "asrt4": {
            "captions": {
                "default": "Now we will tell you a short story. Listen to the story and then retell it with as much detail as you can.",
                "playing": "Listen carefully.",
                "recording": "Retell the story in as much detail as you can."
            }
        },
        "asrt4success": {
            "caption": "Great job!",
            "description": "Continue to the next step when you are ready."
        },
        "asrt4delayed": {
            "captions": {
                "default": "Press “Start” to listen to the instructions.",
                "playing": "Listen carefully.",
                "recording": "Retell the story in as much detail as you can."
            }
        },
        "asrt5": {
            "captions": {
                "default": "Now we will tell you another short story. Listen to the story and then retell it with as much detail as you can.",
                "playing": "Listen carefully.",
                "recording": "Retell the story in as much detail as you can."
            }
        },
        "asrt5success": {
            "caption": "Almost there!",
            "description": "Continue to the next step when you are ready."
        },
        "asrt8": {
            "captions": {
                "default": "Now we will tell you a short story. Listen to the story and then retell it with as much detail as you can.",
                "playing": "Listen carefully.",
                "recording": "Retell the story in as much detail as you can."
            }
        },
        "asrt8success": {
            "caption": "Great job!",
            "description": "Continue to the next step when you are ready."
        },
        "asrt8delayed": {
            "captions": {
                "default": "Press “Start” to listen to the instructions.",
                "playing": "Listen carefully.",
                "recording": "Retell the story in as much detail as you can."
            }
        },
        "asrt9": {
            "captions": {
                "default": "Now we will tell you another short story. Listen to the story and then retell it with as much detail as you can.",
                "playing": "Listen carefully.",
                "recording": "Retell the story in as much detail as you can."
            }
        },
        "asrt9success": {
            "caption": "Almost there!",
            "description": "Continue to the next step when you are ready."
        }
    },
    "audio": {
        "soundCheck": {
            "file": "US\/soundcheck.mp3",
            "duration": "4330"
        },
        "asrt1": {
            "file": "US\/S1_immediate.opus",
            "duration": "66150"
        },
        "asrt2": {
            "file": "US\/S2_immediate.opus",
            "duration": "67530"
        },
        "asrt1delayed": {
            "file": "US\/S1_delayed.opus",
            "duration": "14330"
        },
        "cat": {
            "file": "US\/CAT_Animals.opus",
            "duration": "20410"
        },
        "qc": {
            "file": "US\/QC.opus",
            "duration": "24290"
        },
        "qc_fail_1": {
            "file": "US\/QC_fail_1.opus",
            "duration": "16430"
        },
        "qc_fail_2": {
            "file": "US\/QC_fail_2.opus",
            "duration": "18670"
        },
        "asrt3": {
            "file": "US\/S3_immediate.opus",
            "duration": "63996"
        },
        "asrt3delayed": {
            "file": "US\/S3_delayed.opus",
            "duration": "14444"
        },
        "asrt6": {
            "file": "US\/S6_immediate.opus",
            "duration": "66179"
        },
        "asrt4": {
            "file": "US\/S4_immediate.opus",
            "duration": "69160"
        },
        "asrt4delayed": {
            "file": "US\/S4_delayed.opus",
            "duration": "14214"
        },
        "asrt5": {
            "file": "US\/S5_immediate.opus",
            "duration": "66179"
        },
        "asrt8": {
            "file": "US\/S8_immediate.opus",
            "duration": "68734"
        },
        "asrt8delayed": {
            "file": "US\/S8_delayed.opus",
            "duration": "15793"
        },
        "asrt9": {
            "file": "US\/S9_immediate.opus",
            "duration": "60429"
        }
    }
}